import { SET_SESSION_ID, RESET_SESSION_ID } from "../utils/constants";

const initialState = {
  sessionId: "",
};

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SESSION_ID:
      return {
        ...state,
        sessionId: action.payload || null,
      };
    case RESET_SESSION_ID:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default sessionReducer;
